import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import PurchasePapers from "../components/PurchasePapers";
import Header from "../components/Header";
import Footer from "../components/Footer";
import HeroSlider from "./HeroSlider";


function Home() {

  

  return (
    <>
      <Header />

      <HeroSlider />
      <PurchasePapers />

      <Footer />
    </>
  );
}

export default Home;